import { observer } from 'mobx-react-lite'
import { AddFilterButton } from '@/features/legends/filters/components/AddFilterButton'
import { FilterCardContainer } from '@/features/legends/filters/components/FilterCard/FilterCardContainer'
import {
  IfFilter,
  IfFilterBranch,
} from '@/features/legends/filters/components/IfFilter'
import type {
  IfBranch,
  IfEditorViewModel,
} from '@/features/legends/filters/types/IfEditorViewModel'

export interface IfFilterContainerProps {
  vm: IfEditorViewModel
  isDisabled?: boolean
  testId?: string
}

const branches: [IfBranch, string][] = [
  ['conditionRule', 'If'],
  ['thenRule', 'Then'],
  ['elseRule', 'Else'],
]

export const IfFilterContainer = observer(function IfFilterContainer({
  vm,
  isDisabled,
  testId,
}: IfFilterContainerProps) {
  return (
    <IfFilter>
      {branches.map(([branch, label]) => (
        <IfBranchContainer
          key={branch}
          vm={vm}
          branch={branch}
          label={label}
          isDisabled={isDisabled}
          testId={testId && `${testId}-${label.toLowerCase()}`}
        />
      ))}
    </IfFilter>
  )
})

interface IfBranchContainerProps {
  vm: IfEditorViewModel
  branch: IfBranch
  label: string
  isDisabled?: boolean
  testId?: string
}

const IfBranchContainer = observer(function IfBranchContainer({
  vm,
  branch,
  label,
  isDisabled,
  testId,
}: IfBranchContainerProps) {
  const filterVm = vm[branch]
  const error = vm.validation.getError(branch)
  return (
    <IfFilterBranch label={label} error={error}>
      {filterVm ? (
        <FilterCardContainer
          vm={filterVm}
          isDisabled={isDisabled}
          onRemove={() => vm.removeFilter(branch)}
          testId={testId && `${testId}-filter`}
        />
      ) : (
        <AddFilterButton
          label="Select filter"
          filterTypes={vm.availableFilterTypes}
          onAdd={(type) => vm.setFilter(branch, type)}
          isDisabled={isDisabled}
          isInvalid={!!error}
          testId={testId && `${testId}-add`}
        />
      )}
    </IfFilterBranch>
  )
})
